(function() {
	'use strict';

	angular.module('exportWarehouseApp').controller(
			'StockOutUsedCancelController', StockOutUsedCancelController);

	StockOutUsedCancelController.$inject = [ '$scope', '$filter',
			'NgTableParams', 'FORMAT_DATE', 'StockOutUsedCancelService',
			'$uibModal', '$base64', '$window', '$stateParams', 'EVENT',
			'$state', 'Upload', 'authExpiredInterceptor' ];

	function StockOutUsedCancelController($scope, $filter, NgTableParams,
			FORMAT_DATE, StockOutUsedCancelService, $uibModal, $base64,
			$window, $stateParams, EVENT, $state, Upload,
			authExpiredInterceptor) {
		var vm = this;
		var self = $scope;
		$scope.format = 'dd/MM/yyyy';
		vm.popupCreateDate = false;

		$scope.dateOptions = {
			minDate : new Date(1900, 1, 1),
			maxDate : new Date()
		}
		vm.altInputFormats = [ 'M!/d!/yyyy' ];
		vm.warehouse = {
			status : 'ALL'
		};

		$scope.$on(EVENT.changeOffice, function(event, args) {
			if (event.name = 'CHANGE_OFFICE') {
				$state.go($state.current, {}, {
					reload : true
				});
			}
		});

		vm.warehouse.transferOfficeCode = 'ALL';

		vm.popupCreateDate = false;
		var parent = $scope.$parent;
		
		vm.warehouse.tranferRequestDate = new Date();
		vm.warehouse.createUser = parent.appCtrl.account.fullName;

		vm.param = {};

		vm.wareHouseTable = new NgTableParams({
			page : 1,
			count : 20
		}, {
			total : 0,
			counts : [],
			defaultSort : 'desc',
			getData : function(params) {
				vm.param.uri = "getListStockOutForUsed";
				vm.param.page = params.page();
				vm.param.size = params.count();
				vm.param.sort = params.sorting();
				vm.param.stockOutCode = vm.warehouse.stockOutCode;
				vm.param.createDate = vm.warehouse.createDate;
				vm.param.status = vm.warehouse.status;
				vm.param.typeCode = vm.warehouse.stockOutReason;
				vm.param.officeCode = parent.appCtrl.account.currentOffice.officeCode;
				vm.param.wareHouseCode = vm.warehouse.wareHouseCode;
				if (vm.warehouse.wareHouseCode != undefined
						&& vm.warehouse.wareHouseCode != null) {
					return StockOutUsedCancelService.get(vm.param).$promise
							.then(function(result) {
								params.total(result.totalElements);
								return result.content;
							});
				}
			}
		});

		vm.listProduct = [];

		vm.wareHouseInputTable = new NgTableParams({
			page : 1,
			count : 20
		}, {
			total : 0,
			counts : [],
			defaultSort : 'desc',
			getData : function(params) {
				vm.param.uri = "getListProductStockOutUsedCancel";
				vm.param.page = params.page();
				vm.param.size = params.count();
				vm.param.sort = params.sorting();
				vm.param.stockOutId = vm.warehouse.stockOutId;

				if (vm.warehouse.stockOutId != null
						&& vm.warehouse.stockOutId != '') {
					return StockOutUsedCancelService.query(vm.param).$promise
							.then(function(result) {
								vm.listProduct = result;
								return vm.listProduct;
							});
				}
			}
		});

		vm.search = function() {
			vm.wareHouseTable.page(1);
			vm.wareHouseTable.count(20);
			vm.wareHouseTable.total(0);
			vm.wareHouseTable.reload();
		};

		vm.openDatePicker = function() {
			vm.popupCreateDate = true;
		};

		vm.openPopup = function(stockOutId, typeProcess) {
			var link = GLOBAL_URL + 'stockout/#/createstockOutUsedCancel' + '/'
					+ $base64.encode(typeProcess);
			if (stockOutId !== null) {
				link = link + '/' + $base64.encode(stockOutId);
			}
			$window.open(link, '_self');
		};

		vm.isCreate = false;
		vm.isView = false;
		vm.isAdjust = false;
		vm.isExit = false;
		vm.checkMultiSubmit = 0;
		vm.initPage = function() {
			vm.checkMultiSubmit = 0;
			vm.warehouse.createDate = new Date();
			vm.showCancelReason = false;
			vm.isCannotDeny = false;
//			vm.getListProductGroupItem();
			var typeProcess = $base64.decode($stateParams.typeProcess);
			for (var i = 0; i < listTypeProcessUsedCancel.length; i++) {
				if (typeProcess == listTypeProcessUsedCancel[i].code) {
					vm.title = listTypeProcessUsedCancel[i].name;
					if (i == 0) { // create
						vm.isCreate = true;
						vm.isView = false;
						vm.isAdjust = false;
						vm.isExit = false;
					} else if (i == 1) { // view
						vm.isCreate = false;
						vm.isView = true;
						vm.isAdjust = false;
						vm.isExit = false;
					} else if (i == 2) { // adjust
						vm.isCreate = false;
						vm.isView = false;
						vm.isAdjust = true;
						vm.isExit = false;
					} else if (i == 3) { // exit
						vm.isCreate = false;
						vm.isView = false;
						vm.isAdjust = false;
						vm.isExit = true;
					}
					break;
				}
			}

			vm.getListStock(2);
			if ($stateParams.stockOutId != null) {
				vm.warehouse.stockOutId = $base64
						.decode($stateParams.stockOutId);
				vm.getInfoDetail();
			}
		};

		vm.exit = function() {
			$state.go('stockOutUsedCancel');
		};

		vm.save = function() {
			if (vm.warehouse.showAttachFile) {
				if (vm.warehouse.dataName == null || vm.warehouse.dataName == '') {
					self.addAlert('Bạn chưa chọn file đính kèm.', 'danger');
					return;
				}
			}
			if (vm.listProduct.length == 0) {
				self.addAlert('Bạn chưa chọn sản phẩm xuất kho.', 'danger');
				return;
			} else {
				for (var i = 0, size = vm.listProduct.length; i < size; i++) {
					if(vm.listProduct[i].productGroupItemId == 0 || vm.listProduct[i].productItemId == 0) {
						self.addAlert('Bạn chưa chọn sản phẩm xuất kho.', 'danger');
						return;
					}
				}
			}

			if (vm.warehouse.stockOutReason == undefined
					|| vm.warehouse.stockOutReason == null
					|| vm.warehouse.stockOutReason == '') {
				self.addAlert('Bạn chưa lý do xuất hàng.', 'danger');
				return;
			}
			for (var i = 0, size = vm.listProduct.length; i < size; i++) {
				for(var j = i + 1; j < size; j++) {
					if(vm.listProduct[i].productItemId == vm.listProduct[j].productItemId) {
						self
						.addAlert('Có sản phẩm trùng nhau, xin kiểm tra lại',
								'danger');
						return;
					}
				}
				var productLine = vm.listProduct[i];
				var quantity = 0;
				if (productLine.seriIndicator == true || productLine.seriIndicator == '1') {
					var listSeries = productLine.listSeries;
					for (var j = 0, length = listSeries.length; j < length; j++) {
						var seriesDTO = listSeries[j];
						if (seriesDTO.seriesFrom == null
								|| seriesDTO.seriesFrom == 0) {
							self
									.addAlert('Từ số seri bắt buộc nhập.',
											'danger');
							return;
						}
						if (seriesDTO.seriesTo == null
								|| seriesDTO.seriesTo == 0) {
							self.addAlert('Đến số seri bắt buộc nhập.',
									'danger');
							return;
						}

						if (seriesDTO.seriesFrom != null
								&& seriesDTO.seriesTo != null
								&& seriesDTO.seriesFrom != ''
								&& seriesDTO.seriesTo != '') {
							if (parseInt(seriesDTO.seriesFrom) > parseInt(seriesDTO.seriesTo)) {
								self.addAlert(
										'Từ số seri phải lớn hơn đến số seri.',
										'danger');
								return;
							}
							var minusSeries = parseInt(seriesDTO.seriesTo)
									- parseInt(seriesDTO.seriesFrom) + 1;
							quantity += minusSeries;
						}
					}
					if (quantity != parseInt(productLine.quantity)) {
						self
								.addAlert(
										'Số seri không bằng số lượng nhập, vui lòng xem lại!',
										'danger');
						return;
					}
				}
				if (parseInt(productLine.quantity) == 0) {
					self.addAlert('Số lượng phải lớn hơn 0.', 'danger');
					return;
				}
			}
			vm.checkMultiSubmit = vm.checkMultiSubmit + 1;
			self.loading = true;
			
			var data = [];
			data['product'] = new Blob([ JSON.stringify(vm.listProduct) ], {
				type : "application/json"
			});
			data['wareHouseCode'] = vm.warehouse.wareHouseCode;
			data['stockOutReason'] = vm.warehouse.stockOutReason;
			if (vm.warehouse.stockOutReasonDetail != undefined
					&& vm.warehouse.stockOutReasonDetail != null
					&& vm.warehouse.stockOutReasonDetail != '') {
				data['stockOutReasonDetail'] = vm.warehouse.stockOutReasonDetail;
			}
			if (vm.warehouse.stockOutId != undefined
					&& vm.warehouse.stockOutId != null
					&& vm.warehouse.stockOutId != '') {
				data['stockOutId'] = vm.warehouse.stockOutId;
			}
			data['cancelReason'] = vm.warehouse.cancelReason;
			if (vm.checkMultiSubmit == 1) {
				if (vm.warehouse.attachment !== undefined
						&& vm.warehouse.attachment !== null) {
					data['file'] = vm.warehouse.attachment;
					Upload
							.upload(
									{
										url : GLOBAL_URL
												+ 'api/stockOutUsedCancel/saveStockOutWithAttachment?_csrf='
												+ authExpiredInterceptor
														.getCSRF(),
										data : data
									}).then(
									function(result) {
										$(window).scrollTop(0);
										vm.checkMultiSubmit = 0;
										if (result.data.messages.length == 0) {
											self.addAlert(
													'Thao tác thành công!',
													'success');
											vm.exit();
										}
									}, function(result) {
										$scope.loading = false;
										vm.checkMultiSubmit = 0;
									}, function(evt) {
										$scope.loading = false;
										vm.checkMultiSubmit = 0;
									});
				} else {
					StockOutUsedCancelService
							.post(
									{
										uri : 'saveStockOutForUsedCancel',
										wareHouseCode : vm.warehouse.wareHouseCode,
										stockOutReason : vm.warehouse.stockOutReason,
										stockOutReasonDetail : vm.warehouse.stockOutReasonDetail,
										stockOutId : vm.warehouse.stockOutId,
										cancelReason : vm.warehouse.cancelReason
									}, vm.listProduct, function(result) {
										$(window).scrollTop(0);
										self.loading = false;
										vm.checkMultiSubmit = 0;
										if (result.messages.length == 0) {
											self.addAlert(
													'Thao tác thành công!',
													'success');
											vm.exit();
										}
									}, function(error) {
										if(error.status == '403') {
											$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
										}
										vm.checkMultiSubmit = 0;
										self.loading = false;
									});
				}
			}
		};

		vm.cancel = function() {
			self.loading = true;
			StockOutUsedCancelService
					.returnValue(
							{
								uri : 'cancelStockOut',
								cancelReason : vm.warehouse.cancelReason,
								stockOutId : vm.warehouse.stockOutId
							},
							function(result) {
								$(window).scrollTop(0);
								self.loading = false;
								if (result.response == -1) {
									self
											.addAlert(
													'Phiếu xuất  kho này không thể hủy do đã nhập kho!',
													'danger');
								} else {
									self.addAlert('Thao tác thành công!',
											'success');
								}
								vm.exit();
							}, function() {
								self.loading = false;
							});
		};

		vm.init = function() {
//			vm.getStockOutReason();
			vm.getListStock(1);
		};

		vm.getListOfficeBranch = function() {
			if (vm.warehouse.wareHouseCode != undefined
					&& vm.warehouse.wareHouseCode != null) {
				StockOutUsedCancelService.query({
					uri : 'getListOfficeBranch',
					wareHouseCode : vm.warehouse.wareHouseCode
				}, function(result) {
					if (result != null) {
						vm.warehouse.listRequestOfficeTranferBranch = result;
					}
				});
			}
		};

		vm.getListProductGroupItem = function() {
			StockOutUsedCancelService.query({
				uri : 'getListProductGroupItem',
				wareHouseCode : vm.warehouse.wareHouseCode
			}, function(result) {
				if (result != null) {
					vm.warehouse.listProductGroupItem = result;
				}
			});
		};

		vm.addProduct = function() {
			var product = {
				productGroupItemId : 0,
				productItemId : 0,
				listProductItem : [],
				quantity : 0,
				listSeries : [ {
					seriesFrom : 0,
					seriesTo : 0,
					isIndicator : true,
					idSeries : 1
				} ],
				notes : ""
			}

			vm.listProduct.push(product);
			vm.wareHouseInputTable = new NgTableParams({
				count : vm.listProduct.length
			// hides pager
			}, {
				counts : [], // hide page counts control
				filterDelay : 0,
				dataset : vm.listProduct
			});

		};

		vm.removeProduct = function(index) {
			vm.listProduct.splice(index, 1);
			vm.wareHouseInputTable.reload();
		};

		vm.showMinus = false;
		vm.addRow = function(listSeries) {
			if (vm.isView || vm.isExit) {
				return;
			}
			vm.showMinus = true;
			var id = listSeries.length + 1;
			var seri = {
				idSeries : id,
				seriesFrom : '',
				seriesTo : ''
			}
			listSeries.push(seri);
		};

		vm.removeRow = function(listSeries, indexSeries) {
			if (vm.isView || vm.isExit || vm.showCancelReason
					|| listSeries.length == 1) {
				return;
			}
			var length = listSeries.length;
			var indexPop = -1;
			for (var i = 0; i < length; i++) {
				var ser = listSeries[i];
				if (ser.idSeries == indexSeries) {
					indexPop = i;
					break;
				}
			}
			if (indexPop > -1) {
				listSeries.splice(indexPop, 1);
				length = listSeries.length;
				if (length == 1) {
					vm.showMinus = false;
				}
			}
		};

		vm.getListProductItem = function(productGroupId, index) {
			if (productGroupId != undefined && productGroupId != null
					&& productGroupId != '') {
				StockOutUsedCancelService.query({
					uri : 'getListProductItem',
					productGroupId : productGroupId,
					wareHouseCode : vm.warehouse.wareHouseCode
				}, function(result) {
					if (result != null) {
						var prod = vm.listProduct[index];
						prod.listProductItem = result;
						// vm.wareHouseInputTable.reload();
					}
				});
			}
		};

		vm.getStockOutReason = function() {
			if (vm.warehouse.wareHouseCode != undefined
					&& vm.warehouse.wareHouseCode != null) {
				StockOutUsedCancelService.query({
					uri : 'getStockOutReason',
					wareHouseCode : vm.warehouse.wareHouseCode
				}, function(result) {
					if (result != null) {
						vm.warehouse.listStockOutReason = result;
						if (!vm.isView && !vm.isExit) {
							vm.wareHouseInputTable.reload();
						}
					}
				}).$promise.then(function(result) {
					vm.getListProductGroupItem();
					vm.checkReasonTypeIsLost();
				});
			}
		};

		vm.checkIndicator = function(option, index, productItemId) {
			for (var i = 0; i < option.length; i++) {
				var productItem = option[i];
				if (productItem.productId == productItemId) {
					if (productItem.seriesIndicator == '1') {
						vm.listProduct[index].seriIndicator = true;
					} else {
						vm.listProduct[index].seriIndicator = false;
					}
				}
			}
		};

		vm.getInfoDetail = function() {
			StockOutUsedCancelService
					.get(
							{
								uri : 'getInfoDetail',
								stockOutId : vm.warehouse.stockOutId
							},
							function(result) {
								if (result != null) {
									vm.warehouse.usedCancelCode = result.usedCancelCode;
									vm.warehouse.stockOutReason = result.stockOutReason;
									vm.warehouse.createDate = new Date(
											result.createdDate);
									vm.warehouse.createUser = result.createUser;
									vm.warehouse.stockOutReasonDetail = result.resonStockOut;
									vm.warehouse.cancelReason = result.cancelReason;
									if (result.cancelReason != null
											& result.cancelReason != '') {
										vm.showCancelReason = true;
									}
									vm.warehouse.dataName = result.fileName;
									if (vm.warehouse.dataName != undefined
											&& vm.warehouse.dataName != null
											&& vm.warehouse.dataName != '') {
										vm.warehouse.showAttachFile = true;
									}
									vm.warehouse.dataId = result.reasonShipmentDataId;
									vm.warehouse.denialReason = result.denialReason;
									if(result.denialReason != null && result.denialReason != '') {
										vm.isCannotDeny = true;
									}
									vm.warehouse.wareHouseCode = result.wareHouseCode;
									vm.warehouse.overCutOff = result.overCutOff;
									vm.warehouse.owner = result.owner;
								}
							}).$promise.then(function(result) {
								vm.getStockOutReason();
							});
		};

		vm.warehouse.showAttachFile = false;
		vm.checkReasonTypeIsLost = function() {
			for (var i = 0; i < vm.warehouse.listStockOutReason.length; i++) {
				var reasonShipment = vm.warehouse.listStockOutReason[i];
				if (vm.warehouse.stockOutReason == reasonShipment.reasonId) {
					if (reasonShipment.typeReason == 'LOST') {
						vm.warehouse.showAttachFile = true;
					} else {
						vm.warehouse.showAttachFile = false;
					}
				}
			}
		};

		vm.removeFileAttach = function(file, errFiles) {
			if (file != undefined && file != null) {
				vm.warehouse.dataName = file.name;
			}
		};
		
		vm.getAttachmentInfo = function() {
			self.loading = true;
			StockOutUsedCancelService.get({
				uri : 'getAttachmentInfo',
				dataId : vm.warehouse.dataId
			}, function(result) {
				if (result !== null) {
					vm.download(result);
					self.loading = false;
				}
			}, function(err){
				self.loading = false;
			});
		};
		
		vm.download = function(attach) {
			// danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for
				// IE
				// browser
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.fileName);
				} else {
					var blob = new Blob([ attach ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.fileName);
				}
			} else {
				// truong hop file da luu duoi database
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.dataType
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = attach.fileName;
					aTag.click();
				} else {
					// truong hop file luu tam tren man hinh
					var blob = new Blob([ vm.warehouse.attachment ], {
						type : vm.warehouse.attachment.type
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = vm.warehouse.attachment.name;
					aTag.click();
				}
			}
		};
		
		vm.getListStock = function(typeView) {
			StockOutUsedCancelService
					.query(
							{
								uri : 'getListStock',
//								type : '1',
								officeCode : parent.appCtrl.account.currentOffice.officeCode
							},
							function(result) {
								vm.warehouse.listWarehouse = result;
								if(result.length > 0) {
									vm.warehouse.wareHouseCode = result[0].code;
								} else {
									self.addAlert('Văn phòng này không được phép thao tác chức năng này', 'danger');
								}
							}).$promise.then(function(
									result) {
								if(typeView != undefined && typeView != null && typeView == 1) {
									vm.getStockOutReason();
									vm.search();
								} else if(typeView != undefined && typeView != null && typeView == 2) {
									vm.getStockOutReason();
									vm.getListProductGroupItem();
									/*vm.getStockIn();
									vm.getListPurchaseRequest();
									if (vm.stockInId == undefined || vm.stockInId == null) {
										vm.getDetailPurchaseRequest();
									}*/
								}
							});
		};
	}
})();
